import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Typography, Text } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Button, TextButton } from '@fiverr-private/button';
import { Modal, ModalHeader, ModalBody, ModalTrigger, ModalContent } from '@fiverr-private/overlay';
import { track as mixpanelTrack } from '../../../lib/mixpanel';
import { User } from '../../../lib/interfaces';

const imageUrl =
  'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e2ebe23107cbb295037043060a02c8e9-1687417950145/Email%20image%20header-%20Referral.png';

export const defaultUserImage =
  'https://assetsv2.fiverrcdn.com/assets/v2_globals/missing-image-user-default-14ca8e7588014b07ebdba935ea2fce4c.png';

interface EmailPreviewProps {
  user?: User;
}

export const EmailPreview = ({ user }: EmailPreviewProps) => {
  const onPreviewClick = () => {
    mixpanelTrack('Referral Page Inviter - Preview Email  Button - Click');
  };

  const capitalizedUsername = user?.username ? user.username.charAt(0).toUpperCase() + user.username.slice(1) : '';

  return (
    <Modal>
      <ModalTrigger>
        <TextButton onClick={onPreviewClick} size="sm" variant="underline">
          {translate('referral_program_perseus.invitation.email.preview')}
        </TextButton>
      </ModalTrigger>
      <ModalContent>
        <ModalHeader>
          <div>{translate('referral_program_perseus.invitation.email.preview')}</div>
        </ModalHeader>
        <ModalBody>
          <Container>
            <Image src={imageUrl} width="100%" height="134px" alt="banner" objectFit="cover" />
            <Container height="16px" backgroundColor="grey_500" />
            <Stack
              direction="column"
              alignItems="center"
              backgroundColor="grey_300"
              paddingTop="5"
              paddingBottom="12"
              paddingX="8"
              gap="0"
            >
              <Image
                src={user?.userPhoto ?? defaultUserImage}
                width="60px"
                height="60px"
                borderRadius="circle"
                alt="avatar"
              />

              <Text size="b_xxl" marginTop="4" fontWeight="bold" color="bodyPrimary">
                {`${capitalizedUsername} is tired of keeping Fiverr a secret.`}
              </Text>

              <Text textAlign="center" marginTop="3" color="bodySecondary">
                Discover the easiest way to hire online freelancers and get 10% off your first order. From marketing to
                tech, complete all your projects on Fiverr. On budget. On time.
              </Text>

              <Text marginTop="6" marginBottom="10" color="bodySecondary">
                Sounds too good to be true? See for yourself!
              </Text>

              <Button href="#">Browse Services On Fiverr</Button>

              <Image
                marginTop="8"
                width="120px"
                alt="Thanks"
                src="https://fiverr-res.cloudinary.com/q_auto,f_auto/v1/general_assets/system_emails/thanks.png"
              />

              <span>The Fiverr Team</span>
            </Stack>
            <Container backgroundColor="grey_500" paddingBottom="10" paddingTop="5">
              <Typography size="b_xxs" color="grey_900" lineHeight="b_xxs">
                © Fiverr International Limited 2010-{new Date().getFullYear()}, Fiverr Inc. | 401 Broadway, Suite 1600
                New York NY, 10013 USA.
              </Typography>
              <Typography size="b_xxs" color="grey_900" lineHeight="b_xxs">
                Your personal information will not be stored or used for any marketing purposes.
              </Typography>
            </Container>
          </Container>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
